import { Drawer } from '@/components';
import type { ComponentProps, FC } from 'react';
import { useDrawerState } from '../DrawerStateProvider';
import { ExpenditureBudgetJurisdictionForm } from './ExpenditureBudgetJurisdictionForm';

type Props = ComponentProps<typeof ExpenditureBudgetJurisdictionForm>;

export const ExpenditureBudgetJurisdictionFormDrawer: FC<Props> = ({
  initialValues,
  onSubmit,
}) => {
  const { drawerState, setDrawerState } = useDrawerState();

  return (
    <Drawer
      open={
        drawerState.open &&
        drawerState.type === 'expenditure-budget-jurisdiction'
      }
      onClose={() => {
        setDrawerState({ open: false });
      }}
      destroyOnClose
    >
      <ExpenditureBudgetJurisdictionForm
        initialValues={initialValues}
        onSubmit={onSubmit}
      />
    </Drawer>
  );
};
